export default {
  name: "Parking",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm0 26C9.38 28 4 22.62 4 16S9.38 4 16 4s12 5.38 12 12-5.38 12-12 12zm2-19h-6c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1s1-.45 1-1v-3h5c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8h-5v-6h5c1.65 0 3 1.35 3 3s-1.35 3-3 3z",
  },
}
